import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { asyncScheduler, filter, fromEvent, throttleTime } from 'rxjs';

@Component({
  selector: 'app-event-page-block-slides',
  templateUrl: './event-page-block-slides.component.html',
  styleUrls: ['./event-page-block-slides.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventPageBlockSlidesComponent implements OnInit {
  
  private _swiperRef = null;
  private swiperEl = null;

  @ViewChild('swiper')
  set swiperRef(swiperRef: ElementRef) {
    this._swiperRef = swiperRef;
    if(this._swiperRef) {
      this.swiperEl = new window['Swiper'](this._swiperRef.nativeElement, this.config);
    }
  };
  get swiperRef(): ElementRef {
    return this._swiperRef;
  }

  @Input() block:any = null;

  @Input() index = null;
  
  public id = '';
  public config: any = {} 
  public slides = [];

  constructor() {
    fromEvent(window, 'resize').pipe(
      filter(() => this.swiperEl !== null),
      throttleTime(250, asyncScheduler, {
        leading: true,
        trailing: true
      }),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.swiperEl.updateSize();
    });
   }

  ngOnInit(): void {
    this.id = `slides-${this.index}`;
    this.getImageArr(this.block.slides);

    this.config = {
      autoplay: {
        delay: 5000
      },
      autoHeight: true,
      allowTouchMove: true,
      breakpoints: {
        '460': {
          slidesPerView: 2
        },
        '0': {
          slidesPerView: 1
        }
      },
      spaceBetween: 20,
      navigation: {
        nextEl: `.swiper-button-next.slides-${this.index}`,
        prevEl: `.swiper-button-prev.slides-${this.index}`
      },
      centerInsufficientSlides: true,
      loop: true,
      grabCursor: false,
      centeredSlides: true,
    }
  }

  getImageArr(arr){
    if(arr.length < 4 ){
      this.slides = [...arr,...arr,...arr];
    }else{
      this.slides = arr;
    }
  }
}
